<template>
    <div v-if="tags.length > 0" class="mt-2">
      <span v-for="t in tags" :key="t.id" class="badge badge-info mr-2 mb-2 tag-badge" :title="appliedTag(t)">
        {{ appliedTag(t) }}
      </span>
      <br>
    </div>
</template>

<script setup lang="ts">

withDefaults(defineProps<{tags?: any[]}>(), {
  tags: () => []
})

function appliedTag(value: any): string {
  if (!value) return '';
  return `${value.tag.tag_category.category_identifier} - ${value.tag.name}`;
}
</script>